/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Feedback_Detail_Toggle_ShowInputs */



/**
* | output |
* | --- |
* | "Show individual ratings" |
*
* @param {Feedback_Detail_Toggle_ShowInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const feedback_detail_toggle_show = /** @type {((inputs?: Feedback_Detail_Toggle_ShowInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Feedback_Detail_Toggle_ShowInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Einzelbewertungen anzeigen")
	return /** @type {LocalizedString} */ ("Show individual ratings")
});